<template>
  <div class="none-box">
    <div v-if="noneType === 'search'">
      <img
        class="none-img"
        src="@/assets/img/mobileImg/searchNone.png"
        alt=""
      />
      <p class="none-text">没有搜到相关内容</p>
    </div>
    <div v-else-if="noneType === 'lvList' || noneType === 'zxList'">
      <img class="none-img" src="@/assets/img/mobileImg/lvZxNone.png" alt="" />
      <p class="none-text">暂无{{ noneType === "lvList" ? "论文" : "资讯" }}</p>
    </div>
    <div v-else-if="noneType === 'zzList' || noneType === 'tsList' || noneType === 'bgList'">
      <img class="none-img" src="@/assets/img/mobileImg/tsZzNone.png" alt="" />
      <p class="none-text" v-if="noneType === 'zzList'">暂无专著</p>
      <p class="none-text" v-else-if="noneType === 'tsList'">暂无书籍</p>
      <p class="none-text" v-else>暂无数据</p>
    </div>
    <div v-else-if="noneType === 'pxList' || noneType === 'hyList'">
      <img class="none-img" src="@/assets/img/mobileImg/kcHyNone.png" alt="" />
      <p class="none-text">暂无{{ noneType === "pxList" ? "课程" : "会议" }}</p>
    </div>
    <div v-else-if="noneType === 'bkList' || noneType === 'bjList'">
      <img class="none-img" src="@/assets/img/mobileImg/kcHyNone.png" alt="" />
      <p class="none-text">暂无{{ noneType === "bjList" ? "学者" : "期刊" }}</p>
    </div>
    <div v-else-if="noneType === 'noIssue'">
      <img class="none-img" src="@/assets/img/mobileImg/issueNone.png" alt="" />
      <p class="none-text">本期暂无论文</p>
    </div>
    <div v-else-if="noneType === 'collect'">
      <img
        class="none-img"
        src="@/assets/img/mobileImg/collectNone.png"
        alt=""
      />
      <p class="none-text">暂无收藏</p>
    </div>
    <div v-else>
      <img class="none-img" src="@/assets/img/mobileImg/searchNone.png" alt="" />
      <p class="none-text">暂无数据</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noneType: {
      type: String,
      default: ''
    },
  },
};
</script>

<style scoped lang="scss">
.none-box {
  margin-top: 30%;
  width: 100%;
  height: 100%;
  text-align: center;
  .none-img {
    margin-bottom: 10px;
    width: 35%;
    // height: 24px;
  }
  .none-text {
    font-size: 14px;
    color: #666666;
  }
}
</style>